//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const categoriaProdutoService = {
  findByCodigoDepositante,
};

function findByCodigoDepositante(codigoDepositante) {
  return defaultService.doGet(
    `${urlsConstants.API_CATEGORIA_PRODUTO}${codigoDepositante}`
  );
}
